import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "Point";
const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function usePointState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `use${contextName}State must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export function usePointDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `use${contextName}Dispatch must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export const PointProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
